import Vue from "vue";
import VueRouter from "vue-router";
import Size from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  
  {
    path: "/",
    name: "Design",
    component: () =>
      import(/* webpackChunkName: "motifs" */ "../views/Motifs.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
